import { PageName } from '@/enums/pageName'
import { getTranslation } from '@/utils/localisationUtils'

import { Chart } from '@/shared/icons/chart/Chart'

import { TWeightLossChartPilatesProps } from './types'

export const WeightLossChartPilates = ({
  pagesConfig,
  getItem,
  justInTimeText = 'Just in time for the ',
  preposition = ' by ',
  textGoal = 'Goal',
}: TWeightLossChartPilatesProps) => {
  const currentWeight = JSON.parse(getItem(PageName.weight) || '')
  const weightGoal = JSON.parse(getItem(PageName.weightGoal) || '')
  const currentDate = new Date().toLocaleString(window.config.DEFAULT_LOCALE || 'en-US', {
    day: 'numeric',
    month: 'long',
  })

  const date = new Date(getItem(PageName.eventDate) || '')
    .toLocaleString(window.config.DEFAULT_LOCALE || 'en-US', { day: 'numeric', month: 'long' })
    .replace(/\s\d{4}/, '')

  const event = JSON.parse(getItem(PageName.event) || '')

  const eventParameters = pagesConfig[PageName.event]
  const eventOptions = eventParameters?.options || []
  const eventName = (eventOptions && eventOptions[event]) || {}

  const yourWeight = `${currentWeight?.value} ${currentWeight.measurementSystem}`
  const yourWeightGoal = `${weightGoal?.value} ${weightGoal.measurementSystem}`
  const yourWeightInterim = `${Math.round(
    parseInt(yourWeight) - 0.5 * (parseInt(yourWeight) - parseInt(yourWeightGoal))
  )} ${currentWeight.measurementSystem}`

  const getEventName =
    eventName?.title === 'Other' || eventName?.title === 'No' ? 'Your event' : eventName?.title

  const chartProps = {
    yourWeightGoal: yourWeightGoal as string,
    textGoal: textGoal as string,
    yourWeight: yourWeight as string,
    yourWeightInterim: yourWeightInterim as string,
  }

  return (
    <div className="weight-loss-chart">
      <div className="chart-title">
        <span>{yourWeightGoal}</span>
        {preposition}
        <span>{date}*</span>
      </div>

      <div className="goal">
        <span>
          {justInTimeText}
          <span>{getEventName}!</span>
          {getTranslation('weightLossProgram.justInTimeTextEnd') && (
            <>{getTranslation('weightLossProgram.justInTimeTextEnd')}</>
          )}
        </span>
      </div>
      <div className="date">
        <span>
          {getEventName} - {date}
        </span>
      </div>

      <Chart {...chartProps} />

      <div className="timeline">
        <div className="start">{currentDate}</div>
        <div className="end">{date}</div>
      </div>
    </div>
  )
}
